(function () {
  'use strict';
  angular.module('obex').
  factory('aclService', ['$http', '$q', '$window', 'obexConstant',
    function ($http, $q, $window, obexConstant) {
      return {

      };
    },
	]);
})();



// WEBPACK FOOTER //
// ./client/js/services/acl.service.js